"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllowedConsentGroups = void 0;
const constants_1 = require("./constants");
const isBrowserStorageInfoCategory_1 = require("./isBrowserStorageInfoCategory");
const getCookieValue_1 = require("./getCookieValue");
const getAllowedConsentGroups = (cookie) => {
    // OptanonConsent is OneTurst's cookie that stores user consent data as URLSearchParams.
    const oneTrustCookie = (0, getCookieValue_1.getCookieValue)(cookie, 'OptanonConsent') || undefined;
    const params = new URLSearchParams(oneTrustCookie);
    const groupsParam = params.get('groups');
    // Cookie is not set, user hasn't seen the consent banner yet.
    if (!groupsParam) {
        return undefined;
    }
    const newGroups = Object.assign({}, constants_1.DEFAULT_CONSENT_GROUPS);
    groupsParam.split(',').forEach(group => {
        const [key, value] = group.split(':');
        if ((0, isBrowserStorageInfoCategory_1.isBrowserStorageInfoCategory)(key)) {
            newGroups[key] = value === '1';
        }
    });
    return newGroups;
};
exports.getAllowedConsentGroups = getAllowedConsentGroups;
//# sourceMappingURL=getAllowedConsentGroups.js.map